// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type PathwayShareWithGroupsMutationVariables = PrivateSchemaTypes.Exact<{
  pathwayId: PrivateSchemaTypes.Scalars['PositiveInt'];
  variablesGroups: PrivateSchemaTypes.PathwayShareWithGroupsInput;
}>;


export type PathwayShareWithGroupsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { shareWithGroups?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'PathwayGroupModel' }
        & Pick<PrivateSchemaTypes.PathwayGroupModel, 'group_id' | 'pathway_id'>
      )>> }
    )> }
  )> }
);

export type PathwayShareWithUsersMutationVariables = PrivateSchemaTypes.Exact<{
  pathwayId: PrivateSchemaTypes.Scalars['PositiveInt'];
  variables: PrivateSchemaTypes.PathwayShareWithUsersInput;
}>;


export type PathwayShareWithUsersMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { shareWithUsers?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'PathwayEnrolmentModel' }
        & Pick<PrivateSchemaTypes.PathwayEnrolmentModel, 'id'>
      )>> }
    )> }
  )> }
);

export type PathwayAddUserMutationVariables = PrivateSchemaTypes.Exact<{
  pathwayId: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.PathwayAddUserInput;
}>;


export type PathwayAddUserMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { addUser?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PathwayUserModel' }
        & Pick<PrivateSchemaTypes.PathwayUserModel, 'user_id' | 'pathway_id'>
      )> }
    )> }
  )> }
);

export type PathwayAddGroupMutationVariables = PrivateSchemaTypes.Exact<{
  pathwayId: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.PathwayAddGroupInput;
}>;


export type PathwayAddGroupMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { pathway?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'PathwayModelAsAdmin' }
      & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id'>
      & { addGroup?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PathwayGroupModel' }
        & Pick<PrivateSchemaTypes.PathwayGroupModel, 'group_id' | 'pathway_id'>
      )> }
    )> }
  )> }
);

export type ListGroupsQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type ListGroupsQuery = (
  { __typename?: 'Query' }
  & { groups: Array<(
    { __typename?: 'GroupModelGQLBase' }
    & Pick<PrivateSchemaTypes.GroupModelGqlBase, 'id' | 'name'>
  )> }
);


export const PathwayShareWithGroupsDocument = gql`
    mutation pathwayShareWithGroups($pathwayId: PositiveInt!, $variablesGroups: PathwayShareWithGroupsInput!) {
  admin {
    pathway(id: $pathwayId) {
      id
      shareWithGroups(variables: $variablesGroups) {
        group_id
        pathway_id
      }
    }
  }
}
    `;
export type PathwayShareWithGroupsMutationFn = Apollo.MutationFunction<PathwayShareWithGroupsMutation, PathwayShareWithGroupsMutationVariables>;

/**
 * __usePathwayShareWithGroupsMutation__
 *
 * To run a mutation, you first call `usePathwayShareWithGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayShareWithGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayShareWithGroupsMutation, { data, loading, error }] = usePathwayShareWithGroupsMutation({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *      variablesGroups: // value for 'variablesGroups'
 *   },
 * });
 */
export function usePathwayShareWithGroupsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayShareWithGroupsMutation, PathwayShareWithGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayShareWithGroupsMutation, PathwayShareWithGroupsMutationVariables>(PathwayShareWithGroupsDocument, options);
      }
export type PathwayShareWithGroupsMutationHookResult = ReturnType<typeof usePathwayShareWithGroupsMutation>;
export type PathwayShareWithGroupsMutationResult = Apollo.MutationResult<PathwayShareWithGroupsMutation>;
export type PathwayShareWithGroupsMutationOptions = Apollo.BaseMutationOptions<PathwayShareWithGroupsMutation, PathwayShareWithGroupsMutationVariables>;
export const PathwayShareWithUsersDocument = gql`
    mutation pathwayShareWithUsers($pathwayId: PositiveInt!, $variables: PathwayShareWithUsersInput!) {
  admin {
    pathway(id: $pathwayId) {
      id
      shareWithUsers(variables: $variables) {
        id
      }
    }
  }
}
    `;
export type PathwayShareWithUsersMutationFn = Apollo.MutationFunction<PathwayShareWithUsersMutation, PathwayShareWithUsersMutationVariables>;

/**
 * __usePathwayShareWithUsersMutation__
 *
 * To run a mutation, you first call `usePathwayShareWithUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayShareWithUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayShareWithUsersMutation, { data, loading, error }] = usePathwayShareWithUsersMutation({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function usePathwayShareWithUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayShareWithUsersMutation, PathwayShareWithUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayShareWithUsersMutation, PathwayShareWithUsersMutationVariables>(PathwayShareWithUsersDocument, options);
      }
export type PathwayShareWithUsersMutationHookResult = ReturnType<typeof usePathwayShareWithUsersMutation>;
export type PathwayShareWithUsersMutationResult = Apollo.MutationResult<PathwayShareWithUsersMutation>;
export type PathwayShareWithUsersMutationOptions = Apollo.BaseMutationOptions<PathwayShareWithUsersMutation, PathwayShareWithUsersMutationVariables>;
export const PathwayAddUserDocument = gql`
    mutation pathwayAddUser($pathwayId: PositiveInt!, $input: PathwayAddUserInput!) {
  admin {
    pathway(id: $pathwayId) {
      id
      addUser(input: $input) {
        user_id
        pathway_id
      }
    }
  }
}
    `;
export type PathwayAddUserMutationFn = Apollo.MutationFunction<PathwayAddUserMutation, PathwayAddUserMutationVariables>;

/**
 * __usePathwayAddUserMutation__
 *
 * To run a mutation, you first call `usePathwayAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayAddUserMutation, { data, loading, error }] = usePathwayAddUserMutation({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePathwayAddUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayAddUserMutation, PathwayAddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayAddUserMutation, PathwayAddUserMutationVariables>(PathwayAddUserDocument, options);
      }
export type PathwayAddUserMutationHookResult = ReturnType<typeof usePathwayAddUserMutation>;
export type PathwayAddUserMutationResult = Apollo.MutationResult<PathwayAddUserMutation>;
export type PathwayAddUserMutationOptions = Apollo.BaseMutationOptions<PathwayAddUserMutation, PathwayAddUserMutationVariables>;
export const PathwayAddGroupDocument = gql`
    mutation pathwayAddGroup($pathwayId: PositiveInt!, $input: PathwayAddGroupInput!) {
  admin {
    pathway(id: $pathwayId) {
      id
      addGroup(input: $input) {
        group_id
        pathway_id
      }
    }
  }
}
    `;
export type PathwayAddGroupMutationFn = Apollo.MutationFunction<PathwayAddGroupMutation, PathwayAddGroupMutationVariables>;

/**
 * __usePathwayAddGroupMutation__
 *
 * To run a mutation, you first call `usePathwayAddGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayAddGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayAddGroupMutation, { data, loading, error }] = usePathwayAddGroupMutation({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePathwayAddGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PathwayAddGroupMutation, PathwayAddGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PathwayAddGroupMutation, PathwayAddGroupMutationVariables>(PathwayAddGroupDocument, options);
      }
export type PathwayAddGroupMutationHookResult = ReturnType<typeof usePathwayAddGroupMutation>;
export type PathwayAddGroupMutationResult = Apollo.MutationResult<PathwayAddGroupMutation>;
export type PathwayAddGroupMutationOptions = Apollo.BaseMutationOptions<PathwayAddGroupMutation, PathwayAddGroupMutationVariables>;
export const ListGroupsDocument = gql`
    query listGroups {
  groups {
    id
    name
  }
}
    `;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
      }
export function useListGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<typeof useListGroupsLazyQuery>;
export type ListGroupsQueryResult = Apollo.QueryResult<ListGroupsQuery, ListGroupsQueryVariables>;